define('plugin/facebook-pixel/ContentDataFactory',['require','marionette','../facebook-pixel/PromotionInflator','../facebook-pixel/PackageInflator','../facebook-pixel/BookingInflator','../facebook-pixel/MembershipInflator'],function (require) {

    var Marionette = require('marionette');
    var PromotionInflator = require('../facebook-pixel/PromotionInflator');
    var PackageInflator = require('../facebook-pixel/PackageInflator');
    var BookingInflator = require('../facebook-pixel/BookingInflator');
    var MembershipInflator = require('../facebook-pixel/MembershipInflator');

    /**
     * Content data inflator for Facebook Pixel plugin data
     *
     * @class ContentDataFactory
     */
    return Marionette.Object.extend({
    },{
        create: function(type) {
            switch (type) {
                case 'promotion': return new PromotionInflator();
                case 'package': return new PackageInflator();
                case 'membership': return new MembershipInflator();
                default: return new BookingInflator();
            }
        }
    });
});

